import Audit from './audit.vue'
import System from './system.vue'
import IpWhitelist from './ip-whitelist.vue'
import AllAgents from './all-agents.vue'
import Ingest from './ingest.vue'
import Guardrails from './guardrails.vue'

const __default__ = {
  data() {
    return {
      active: 'system',
      tabs: [
        {value: 'system', title: 'System'},  
        {value: 'guardrails', title: 'Guardrails'},
        {value: 'ip-whitelist', title: 'IP Whitelist'},
        {value: 'ingest', title: 'Ingest'},
        {value: 'audit', title: 'Audit'},
        // {value: 'all-agents', title: 'All Agents'}
      ]
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'superuser',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { Audit, System, IpWhitelist, AllAgents, Ingest, Guardrails }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})